const env = {
  NODE_ENV: process.env.REACT_APP_NODE_ENV || "development",
  PORT: process.env.PORT || 3000,
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/api/v1/",
  MOSTAZA_SERVICES_APITOKEN:
    process.env.REACT_APP_MOSTAZA_SERVICES_APITOKEN || "VNwHFfyDeX6VgFqb",
};

export default env;
